import is from "is";
export const isError = (err) => {
    return is.error(err);
};
export const isStatusError = (err) => {
    return isError(err) ? err.name === "StatusError" : false;
};
export const isObject = (data) => {
    return is.object(data);
};
export const isObjectEqual = (data1, data2) => {
    if (isObject(data1) && isObject(data2)) {
        const props1 = Object.getOwnPropertyNames(data1);
        const props2 = Object.getOwnPropertyNames(data2);
        if (props1.length != props2.length) {
            return false;
        }
        for (let i = 0; i < props1.length; i++) {
            const val1 = data1[props1[i]];
            const val2 = data2[props1[i]];
            const isObjects = isObject(val1) && isObject(val2);
            if ((isObjects && !isObjectEqual(val1, val2)) ||
                (!isObjects && val1 !== val2)) {
                return false;
            }
        }
        return true;
    }
    return false;
};
export const isValidationError = (data) => {
    return isObject(data) && is.string(data.message) && isObject(data.errors);
};
export const isNumber = (data) => {
    return is.number(data);
};
export const isString = (data) => {
    return is.string(data);
};
